import React, { useState } from "react";
import { ButtonHLPure, CheckBoxHLPure, GridSelectionHLPure, SimpleLoading } from "../../pures";
import { useTranslation } from "react-i18next";
import "./contractors-catalog-sort.view.css";
import { Grid } from "@material-ui/core";
import { useEffect } from "react";


const clasifiers = [

    {
        "id": 1,
        "name": 'Contratante',
        "isAssigned": false
    },
    {
        "id": 2,
        "name": 'Proveedor REPSE',
        "isAssigned": false
    },
]


const ContractorsCatalogSort = (props) => {
    const { t } = useTranslation();


    let {
        token,
        hideShowDetails,
        nameComponentUser,
        isLoadingView,
        contractorGridSelected,
        setNameComponentUser,
        setShowDetails,
        backGridView,
        companiesToClassified,
        contractorCompanyInsertDelete,
        getConractorsForService,
        contractorClassifierInsertDelete,
        dataContractors,
        setDataContractors,
        updateGrid
    } = props

    const [companiesGrid, setCompaniesGrid] = useState([])
    const [companySelectedGrid, setCompanySelectedGrid] = useState({})
    const [clasifiersGrid, setClasifiersGrid] = useState([])
    const [clasifierSelectedGrid, setClasifierSelectedGrid] = useState({})
    const [labelModified, setLabelModified] = useState('')
    const [modifyUser, setModifyUser] = useState(false)
    const [originalState, setOriginalState] = useState()

    const styleGrid = {
        fontFamily: "Quicksand, sans-serif",

    }

    const headerColumnOne = (props) => {
        let styleHeader = {
            color: "#123513",
            fontSize: "14px",
            fontWeight: 600,
            display: "flex",
            justifyContent: "start",
            fontFamily: "Quicksand",
            paddingLeft: '20px',
        };
        return <span style={styleHeader}>{props.title}</span>;
    };

    const headerColumnOneClasifiers = (props) => {
        let styleHeader = {
            color: "#123513",
            fontSize: "14px",
            fontWeight: 600,
            display: "flex",
            justifyContent: "start",
            fontFamily: "Quicksand",
            paddingLeft: '20px',
        };
        return <span style={styleHeader}>{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className="contractorsCatalogSort-cell-one">
                <div className="contractorsCatalogSort-cell-one-div">
                    <CheckBoxHLPure
                        checkedState={props.dataItem.isAssigned}
                        onChangeHandler={(e) => onChangeCheckBox(e, props.dataItem)}
                    />
                    <span className="contractorsCatalogSort-containerLabel">
                        {props.dataItem.name}
                    </span>
                </div>
            </td>
        );
    };

    const cellColumnOneClasifiers = (props) => {
        return (
            <td className="contractorsCatalogSort-cell-one">
                <div className="contractorsCatalogSort-cell-one-div">
                    <CheckBoxHLPure
                        checkedState={props.dataItem.isAssigned}
                        onChangeHandler={(e) => onChangeCheckBoxClasifiers(e, props.dataItem)}
                    />
                    <span className="contractorsCatalogSort-containerLabel">
                        {props.dataItem.name}
                    </span>
                </div>
            </td>
        );
    };


    useEffect(() => {
        if (nameComponentUser !== t("contractorsCatalogView-btn-sort") || !companiesToClassified || !contractorGridSelected) return
        let copyCompaniesToClassified = [...companiesToClassified]
        let companiesClassified = copyCompaniesToClassified.map((company) => {
            let companyAssigned = contractorGridSelected.company.find((companyUser) => companyUser.id === company.id)
            if (companyAssigned) {
                company.isAssigned = true
            } else {
                company.isAssigned = false
            }
            return company
        })
        setCompaniesGrid(companiesClassified)
    }, [companiesToClassified, contractorGridSelected])

    useEffect(() => {
        if (nameComponentUser !== t("contractorsCatalogView-btn-sort") || !contractorGridSelected) return

        let copyClasifiers = [...clasifiers]
        let classifiersContractor = copyClasifiers.map((classifier) => {
            let contractorClassifier = contractorGridSelected.classifiers.find((contractorClassifier) => contractorClassifier.classifierId === classifier.id)
            if (contractorClassifier) {
                classifier.isAssigned = true
            } else {
                classifier.isAssigned = false

            }
            return classifier
        })
        setClasifiersGrid(classifiersContractor)

        let user = (contractorGridSelected && contractorGridSelected.updatedByUser && contractorGridSelected.updatedByUser !== '') ? contractorGridSelected.updatedByUser : ''
        let date = (contractorGridSelected && contractorGridSelected.date && contractorGridSelected.date !== '') ? `${contractorGridSelected.date}` : ''
        let label = `${t("contractorsCatalogSort.labels.modify", {user,  date})}`
        setLabelModified(label)
        setOriginalState([...clasifiers.map((item) => { return { ...item } })])
    }, [contractorGridSelected])

    const filterChangeCompanies = () => {
        console.log('')
    }

    const onChangeCheckBox = (e, dataItem) => {
        let value = e.target.checked


        let contractorId = contractorGridSelected.id
        let companyId = dataItem.id
        let action = (value === true) ? 1 : 2
        contractorCompanyInsertDelete(contractorId, companyId, action, dataItem, value, mapCompaniesWhenOk)
    }

    const onChangeCheckBoxClasifiers = (e, dataItem) => {
        let value = e.target.checked
        let contractorId = contractorGridSelected.id
        let classifierId = dataItem.id
        let action = (value === true) ? 1 : 2

        contractorClassifierInsertDelete(contractorId, classifierId, action, dataItem, value, mapClassifiersWhenOk)
    }

    let mapCompaniesWhenOk = (dataItem, value) => {
        let copyCompanies = [...companiesToClassified]
        copyCompanies.map((company) => {
            if (company.id === dataItem.id) {
                company.isAssigned = value
            }
            return company
        })
        setCompaniesGrid(copyCompanies)
    }

    let mapClassifiersWhenOk = (dataItem, value) => {
        let copyClasifiers = [...clasifiers]
        copyClasifiers.map((clasifier) => {
            if (clasifier.id === dataItem.id) {
                clasifier.isAssigned = value
            }
            return clasifier
        })
        setClasifiersGrid(copyClasifiers)
        if (JSON.stringify(clasifiers) === JSON.stringify(originalState)) {
            setModifyUser(false)
        } else {
            setModifyUser(true)
        }
    }

    const handleBack = async () => {
        let copyContractors = [...dataContractors]
        if (modifyUser) {
            props.toggleLoadingRequesting(true)
            let contractorToModify = copyContractors.find((item) => item.id === contractorGridSelected.id)
            let contractorToModifyIndex = copyContractors.findIndex((item) => item.id === contractorGridSelected.id)
            let classifierId = [...clasifiers].find((item) => item.id === props.paramsId)

            let newData = await updateGrid(Number(contractorGridSelected.id))

            contractorToModify.classifiers = newData

            if (contractorToModify.classifiers.length === 0 || classifierId.isAssigned === false) {
                copyContractors.splice(contractorToModifyIndex, 1)
            } else if (contractorToModify.classifiers.length !== 0 && classifierId.isAssigned === true) {
                copyContractors.splice(contractorToModifyIndex, 1, contractorToModify)
            }
            props.toggleLoadingRequesting(false)
        }
        setDataContractors(copyContractors)
        setNameComponentUser("")
        setShowDetails(false)
        setModifyUser(false)
    }

    return (
        <div className="contractorsCatalogSort-wrapper">
            {isLoadingView ? (
                <SimpleLoading />
            ) : (
                <div className="contractorsCatalogSort-container">
                    <div className="contractorsCatalogSort-subtitle">
                        <h1>{contractorGridSelected.name}</h1>
                    </div>
                    <div className="contractorsCatalogSort-container-grids">
                        <div className="contractorsCatalogSort-company-grid">
                            <Grid
                                item
                                className="contractorsCatalogSort-gridContainer"
                            >
                                <GridSelectionHLPure
                                    skip={0}
                                    take={6}
                                    dataGrid={companiesGrid}
                                    filter={true}
                                    onFilterChange={filterChangeCompanies}
                                    onSelectedItem={setCompanySelectedGrid}
                                    styleGrid={styleGrid}
                                    cellColumnOne={cellColumnOne}
                                    headerColumnOne={headerColumnOne}
                                    titleRow1={t("contractorsCatalogSort.grid.title.companies")}
                                    widthColumnOne={100}
                                    setNameComponentUser={setNameComponentUser}
                                    setShowDetails={setShowDetails}
                                    pageable={false}
                                />
                            </Grid>
                        </div>
                        <div className="contractorsCatalogSort-clasifiers-grid">
                            <Grid
                                item
                                className="contractorsCatalogSort-gridContainer-clasifiers"
                            >
                                <GridSelectionHLPure
                                    skip={0}
                                    take={6}
                                    dataGrid={clasifiersGrid}
                                    filter={true}
                                    onFilterChange={filterChangeCompanies}
                                    onSelectedItem={setClasifierSelectedGrid}
                                    styleGrid={styleGrid}
                                    cellColumnOne={cellColumnOneClasifiers}
                                    headerColumnOne={headerColumnOneClasifiers}
                                    titleRow1={t("contractorsCatalogSort.grid.title.classifiers")}
                                    widthColumnOne={100}
                                    setNameComponentUser={setNameComponentUser}
                                    setShowDetails={setShowDetails}
                                    pageable={false}
                                />
                            </Grid>
                        </div>
                    </div>
                    <div className="contractorsCatalogSort-container-label-modified">
                        <p>
                            {labelModified}
                        </p>
                    </div>
                    <div className="contractorsCatalogSort-container-btns">
                        <ButtonHLPure
                            nameBtn={t("signRequestByVolume.exit")}
                            primary={false}
                            onClickBtn={handleBack}
                        />
                    </div>
                </div>
            )
            }
        </div>
    )
}

export default ContractorsCatalogSort